// export const environment = {
//   production: true,
//   appConfig: 'appconfig.production.json',
//   firebaseConfig : {
//     apiKey: 'AIzaSyBG9WyCnVXa3GvOYDLN8aSWz_VT5_y-MLk',
//     authDomain: 'mashwrah-testing.firebaseapp.com',
//     databaseURL: 'https://mashwrah-testing.firebaseio.com',
//     projectId: 'mashwrah-testing',
//     storageBucket: 'mashwrah-testing.appspot.com',
//     messagingSenderId: '787460196251',
//     appId: '1:787460196251:web:ff978f1662d00aa901433e',
//     measurementId: 'G-LD7NK9JE0C'
//   }
// };
export const environment = {
  production: false,
  appConfig: 'appconfig.json',
  firebaseConfig : {
    apiKey: 'AIzaSyCdwKd7uO17knaoZGcrOXDYIUA7zMPNBJE',
    authDomain: 'mashvra.com',
    databaseURL: 'https://mashwrah.firebaseio.com',
    projectId: 'mashwrah',
    storageBucket: 'mashwrah.appspot.com',
    messagingSenderId: '85149850941',
    appId: '1:85149850941:web:bb928c1b7a8f1974f3b954',
    measurementId: 'G-T8LXGGN0H0'
  }
};
